import styled from '@emotion/styled';
import { WHITE, APP_TEMA, LIGHT_GRAY } from '../../../../../styles/color';

export const Layout = styled.header`
  grid-area: header;
  border-bottom: 1px solid ${LIGHT_GRAY};
  background-color: ${APP_TEMA};
  width: 100%;
  box-sizing: border-box;
  min-width: 0;
  padding: 0;
`;

export const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  height: 80px;
  padding: 8px 52px;

  > h2 {
    margin: 0;
    color: ${WHITE};
    font-size: clamp(16px, 4.5vw, 24px);
    line-height: 1.4;
    text-align: center;
  }
`;

export const HeaderBrand = styled.div`
  width: 100%;
  height: 16px;
  background-color: ${WHITE};
  background-image: url("${({ $logo }) => $logo}");
  background-repeat: repeat-x;
  background-position: center;
  background-size: auto 100%;
`;
